import { ResHandle, deleteEmptyObj, formatCST } from '@/utils/utils'
import app from '@/main'
import axios from 'axios'

const state = {
  page: 1,
  total: 0,
  limit: 15,
  class_name: '', // 班级名
  creator_name: '', // 创建者
  date: [],
  teacher_id: '',
  created_at_from: null, // 创建时间
  created_at_to: null, // 结束时间
  unit_name: '' // 单位名称
}

const actions = {
  // student get data
  async classManageGetData({ commit, state, rootState }, playload) {
    const unit_id = rootState.user.role_id
    const page = state.page
    if (unit_id === 40001) {
      const data = {
        name: state.class_name,
        creator_name: state.creator_name,
        created_at_to: state.created_at_to && formatCST(state.created_at_to),
        created_at_from:
          state.created_at_from && formatCST(state.created_at_from),
        unit_name: state.unit_name,
        teacher_id: state.teacher_id
      }
      deleteEmptyObj(data)
      const res = await API.get(
        `/edu/zone/channel/agent/class?page=${page}`,
        data
      )
      if (res.status < 400) {
        commit('setState', {
          module: 'classManage',
          key: 'total',
          value: res.data.total
        })
        return res
      }
    } else {
      const data = {
        class_name: state.class_name,
        creator_name: state.creator_name,
        created_at_to: state.created_at_to && formatCST(state.created_at_to),
        created_at_from:
          state.created_at_from && formatCST(state.created_at_from),
        teacher_id: state.teacher_id
      }
      deleteEmptyObj(data)
      const res = await API.get(`/edu/zone/classes?page=${page}`, data)
      if (res.status < 400) {
        commit('setState', {
          module: 'classManage',
          key: 'total',
          value: res.data.total
        })
        return res
      }
    }
  },
  // add class
  async classManageAddClass({ commit }, data) {
    const res = await API.post(`/edu/zone/class`, data)

    return res
  },
  // 批量添加学生
  async classManageAddStudent({ commit }, data) {
    try {
      const res = await API.post(
        `/edu/zone/class/${data.id}/students`,
        {
          student_names: data.studentNames
        },
        { responseType: 'arraybuffer' }
      )
      return res
    } catch (error) {
      return error
    }
  },
  // 修改班级名
  async classManageEditName({ commit }, data) {
    const res = await API.patch(`/edu/zone/class/${data.id}`, {
      name: data.name
    })
    return ResHandle(res)
  },
  // 根据用户名 手机号 邮箱 查询学生信息
  async classManageGetStudent({ commit }, data) {
    const res = await API.get(`/edu/zone/class/student`, { identity: data })
    return res
  },
  // 获取班级中的学生信息 (用于移除学生)
  async classManageGetStudentList({ commit }, id) {
    const res = await API.get(`/edu/zone/class/${id}/students`)
    return res
  },

  // 班级里删除学生
  async classManageDeleteStudent({ commit }, data) {
    const res = await API.delete(`/edu/zone/class/${data.id}/students`, {
      student_ids: data.student_ids
    })
    return res
  },
  async classManageExcel({ commit }, value) {
    const data = {
      class_name: state.class_name,
      creator_name: state.creator_name,
      created_at_to:
        state.created_at_to &&
        formatCST(moment(state.created_at_to).add(24, 'h')),
      created_at_from:
        state.created_at_from && formatCST(state.created_at_from),
      teacher_id: state.teacher_id
    }
    deleteEmptyObj(data)
    const res = await API.get(`/edu/zone/classes/excel`, data, {
      responseType: 'arraybuffer'
    })
    return res
  },
  async addExistStudent({ commit }, data) {
    const res = await API.post(
      `/edu/zone/class/${data.classId}/student/${data.studentId}`
    )
    return res
  },
  // 批量查询学生接口
  async batchQueryStudent({ commit }, data) {
    const res = await API.post(
      `/edu/zone/class/${data.classId}/students/query`,
      data
    )
    return res
  },
  // 批量添加学生的接口
  async batchAddStudent({ commit }, data) {
    const res = await API.post(
      `/edu/zone/class/${data.classId}/students/add`,
      data
    )
    return res
  },
  // 批量邀请学生加入班级
  async batchAddStudentInvite({ commit }, data) {
    const token = await app.$auth('get_access_token')
    try {
      const res = await axios({
        method: 'post',
        url: `${CONFIG.api_edu}/edu/zone/class/${data.classId}/students/invite`,
        headers: {
          Authorization: token,
          Authorization_Type: 3
        },
        data
      })
      return res
    } catch (err) {
      return err.response
    }
  }
}

const mutations = {
  classManageInit(state) {
    state.date = []
    state.class_name = ''
    state.page = 1
    state.creator_name = ''
    state.unit_name = ''
    state.created_at_from = null
    state.created_at_to = null
  },
  classManageInitTeacher(state, value) {
    state.teacher_id = value
  }
}

export default {
  state,
  actions,
  mutations
}
